/** Helper utility functions. */

type ToastOptions = {
  dedupeKey?: string;
  dedupeWindowMs?: number;
};

const recentToastByKey = new Map<string, number>();

export function showLoader(elementId: string, show: boolean): void {
  const element = document.getElementById(elementId);
  if (!element) return;
  
  if (show) {
    element.classList.remove('hidden');
    element.style.display = '';
  } else {
    element.classList.add('hidden');
    element.style.display = 'none';
  }
}

export function showContent(elementId: string, show: boolean): void {
  const element = document.getElementById(elementId);
  if (!element) return;
  
  if (show) {
    element.classList.remove('hidden');
    element.style.display = '';
  } else {
    element.classList.add('hidden');
    element.style.display = 'none';
  }
}

export function showToast(message: string, isError: boolean = false, options?: ToastOptions): void {
  const toast = document.getElementById('toast-notification');
  if (!toast) return;

  const dedupeKey = options?.dedupeKey;
  if (dedupeKey) {
    const dedupeWindowMs = options?.dedupeWindowMs ?? 2500;
    const now = Date.now();
    const lastShownAt = recentToastByKey.get(dedupeKey);
    if (lastShownAt && now - lastShownAt < dedupeWindowMs) {
      return;
    }
    recentToastByKey.set(dedupeKey, now);
  }
  
  toast.textContent = message;
  toast.className = `fixed bottom-5 right-5 ${
    isError ? 'bg-red-600' : 'bg-blue-600'
  } text-white py-2 px-4 rounded-lg shadow-lg transform translate-y-0 opacity-100 transition-all duration-300 ease-in-out z-50`;
  
  setTimeout(() => {
    toast.className = toast.className.replace('translate-y-0 opacity-100', 'translate-y-20 opacity-0');
  }, 3000);
}

